import supabaseClient from '@/api/supabaseClient.ts';
import { useQuery } from '@tanstack/react-query';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

export type Message = {
  id: string;
  sender_id: string;
  receiver_id: string;
  content: string;
  is_read: boolean;
  created_at: string;
  updated_at: string;
};

const useMessages = (otherUserId: string | undefined) => {
  const queryFn = async (): Promise<Message[]> => {
    if (!otherUserId) return [];

    const { data, error } = await supabaseClient.functions.invoke('get_messages', {
      method: 'POST',
      body: { other_user_id: otherUserId },
    });

    if (error) {
      if (error instanceof FunctionsHttpError) {
        const err: BackendErrorResponse = await error.context.json();
        throw new Error(err.errors.join(', '));
      }
      throw new Error((error as Error).message);
    }

    return data?.data?.messages || [];
  };

  return useQuery<Message[], Error>({
    queryKey: ['messages', otherUserId],
    queryFn,
    enabled: !!otherUserId,
    refetchInterval: 3000, // Refetch every 3 seconds for real-time updates
  });
};

export default useMessages;
